import { Palette } from '@mui/material';
export const getStarredSpaceColors = (palette: Palette) => {
  const safePalette: any = palette || {};
  const isDark = safePalette.mode === 'dark';
  const commonColors = safePalette.common || {
    white: '#FFFFFF',
    black: '#000000',
  };
  return {
    avatarBg: isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
    avatarIcon: isDark ? commonColors.white : commonColors.black,
    starIcon: isDark ? '#D0BCFA' : '#452188',
    textSecondary: 'text.secondary',
    emptyPanelBg: isDark ? 'rgba(35, 31, 41, 1)' : 'rgba(248, 247, 249, 1)',
    emptyIconCircleBg: isDark
      ? 'rgba(255, 255, 255, 0.12)'
      : 'rgba(0, 0, 0, 0.12)',
    emptyIconColor: isDark
      ? 'rgba(255, 255, 255, 0.12)'
      : 'rgba(0, 0, 0, 0.12)',
    emptyTitleColor: isDark ? 'rgba(255, 255, 255, 1)' : 'text.primary',
    linkColor: isDark ? '#D0BCFA' : '#452188',
    widgetMenuIcon: isDark
      ? 'rgba(255, 255, 255, 0.56)'
      : 'rgba(35, 31, 41, 0.56)',
  } as const;
};
